import { Map } from 'immutable';
import { POPULATE_CAMPAIGNS, POPULATE_EVENT_USERS } from '@constants/actions';
import { CAMPAIGN_EVENT_USER_STATUS } from '@localisation/components';

const aggregationInitial = Object.values(CAMPAIGN_EVENT_USER_STATUS).reduce((countObject, userStatus) => {
  const newCountObject = { ...countObject };
  newCountObject[userStatus.status] = 0;
  return countObject;
}, {});

const initialState = Map({
  campaignList: [],
  campaignTotalCount: 0,
  userList: [],
  userTotalCount: 0,
  userAggregation: aggregationInitial,
});

const Campaign = (state = initialState, action) => {
  const actionPayload = action.payload;
  switch (action.type) {
    case POPULATE_CAMPAIGNS:
      return state.set('campaignList', actionPayload.campaigns)
        .set('campaignTotalCount', actionPayload.campaignTotalCount);
    case POPULATE_EVENT_USERS:
      const newAggregation = actionPayload.aggregation;
      const newUserAggregation = { ...aggregationInitial };
      if (newAggregation) {
        newAggregation.forEach(aggregation => {
          newUserAggregation[aggregation.status] = aggregation.count;
        });
      }

      return state.set('userList', actionPayload.eventUsers)
        .set('userTotalCount', actionPayload.userTotalCount)
        .set('userAggregation', newUserAggregation);
    default:
      return state;
  }
};

export default Campaign;